import { Component, OnInit } from '@angular/core'
import { collection, doc, DocumentData, Firestore, getDocs, orderBy, query, QuerySnapshot } from '@angular/fire/firestore'
import { ActivatedRoute } from '@angular/router'
import { of, throwError } from 'rxjs'
import { flatMap } from 'rxjs/operators'
import { DocumentEnumType } from 'src/app/components/documents/documents.component'
import { DocumentEntry, trainerDocumentTypesArray } from 'src/domain/document'

@Component({
    templateUrl: './trainer-document.component.html',
    styleUrls: ['./trainer-document.component.scss'],
    standalone: false
})
export class TrainerDocumentsComponent implements OnInit {
  documentTypes: DocumentEnumType[] = trainerDocumentTypesArray

  trainerId: string
  trainerName: string
  allDocuments: DocumentEntry[]

  constructor(private route: ActivatedRoute, private store: Firestore) {}

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        flatMap((param) => {
          this.trainerId = param.get('trainerId')
          this.trainerName = param.get('trainerName')

          if (this.trainerId) {
            return of(this.trainerId)
          } else {
            return throwError('Nincs kiképző azonosító megadva')
          }
        })
      )
      .subscribe(
        () => this.refreshDocuments(),
        (e) => console.error(e)
      )
  }

  refreshDocuments() {
    const trainerDoc = doc(this.store, 'trainers', this.trainerId)
    getDocs(query(collection(trainerDoc, 'documents'), orderBy('documentDate', 'desc'))).then((data: QuerySnapshot<DocumentData>) => {
      this.allDocuments = data.docs.map((d) => {
        const docData = d.data() as DocumentEntry
        return {
          docId: d.id,
          downloadUrl: docData.downloadUrl,
          type: docData.type,
          fileType: docData.fileType || 'application/pdf',
          createdBy: docData.createdBy,
          createdAt: (docData.createdAt as any).toDate(),
          documentDate: (docData.documentDate as any).toDate(),
        }
      })
    })
  }
}
